import { Button } from 'components/Elements';
import { Form, InputField, PhoneInputField } from 'components/Form';
import PropTypes from 'prop-types';
import * as z from 'zod';

import { useState } from 'react';
import { useAuth } from 'lib/auth';

const schema = z.object({
  phoneNumber: z.string().min(1, 'Required'),
  password: z.string().min(1, 'Required'),
});

export const LoginForm = ({ onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();

  return (
    <div>
      <Form
        onSubmit={async (values) => {
          setLoading(true);
          await login({
            phoneNumber: values.phoneNumber,
            password: values.password,
          }).catch(() => {
            setLoading(false);
          });
          onSuccess();
        }}
        schema={schema}
      >
        {({ register, formState }) => (
          <>
            <InputField
              type="text"
              label="Phone Number"
              placeholder="e.g 2567..."
              error={formState.errors['phoneNumber']}
              registration={register('phoneNumber')}
            />
            <InputField
              type="password"
              label="Password"
              error={formState.errors['password']}
              registration={register('password')}
            />
            <div>
              <Button isLoading={loading} type="submit" className="w-full">
                Continue
              </Button>
            </div>
          </>
        )}
      </Form>
    </div>
  );
};

LoginForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};
